import { render, staticRenderFns } from "./DialogEstruturaComercial.vue?vue&type=template&id=e4a8780e&scoped=true&"
import script from "./DialogEstruturaComercial.vue?vue&type=script&lang=js&"
export * from "./DialogEstruturaComercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a8780e",
  null
  
)

export default component.exports